import axios from 'axios';
import apisUrls from '../urls';

const getAllWebsiteRequestsApi = (paramsFilter) => {
  return axios.get(apisUrls?.getWebsiteRequests(paramsFilter));
};

export default getAllWebsiteRequestsApi;
